export const getLandOrPortExThumb = (exVidOrientation, ex) => {
  if (ex?.orientation === exVidOrientation && ex?.thumbnail) {
    // migrated to adaptive bitrate
    return ex?.thumbnail
  } else {
    // legacy
    return exVidOrientation === 'landscape' ? ex?.thumbnail : ex?.portraitThumbnail
  }
}

export const getLandOrPortExVid = (exVidOrientation, ex) => {
  if (ex?.orientation === exVidOrientation && ex?.videoAssets?.hls) {
    // migrated to adaptive bitrate
    return ex?.videoAssets?.hls
  } else {
    // legacy
    return exVidOrientation === 'landscape' ? ex?.video : ex?.portraitVid
  }
}

export const getLandOrPortExVidForPlayer = (exVidOrientation, ex) => {
  if (ex?.orientation === exVidOrientation && ex?.videoAssets?.mp4?.['1080p']) {
    // migrated to adaptive bitrate
    // browser native <video/> component cannot play .m3u8 files, so use 1080p
    return ex?.videoAssets?.mp4?.['1080p']
  } else {
    // legacy
    return exVidOrientation === 'landscape' ? ex?.video : ex?.portraitVid
  }
}
